/* Badge1.js */
/* @author: anghello */

import React from 'react';
import { Badge } from 'reactstrap';
import './badge1.scss';
export default function Badge1({ children }) {
  return (
    <Badge color='dark' className='border-radius-0'>{children}</Badge>
  );
}
